@import "tailwindcss";
@config "../tailwind.config.js";

@layer base {
  /* CRITICAL: Vite production full-screen fix */
  html, body, #root {
    min-height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    background: black;
  }

  body {
    background-color: #000000;
    color: white;
    font-family: 'Space Grotesk', sans-serif;
    margin: 0;
    padding: 0;
  }
}

@layer components {
  /* CRT SCAN FILTER */
  .crt-overlay {
    background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%), 
                linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));
    background-size: 100% 2px, 3px 100%;
    pointer-events: none;
    z-index: 25;
  }

  /* SCANLINE EFFECT */
  .scanline {
    width: 100%;
    height: 100px;
    z-index: 5;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 255, 255, 0.1) 50%, rgba(0, 0, 0, 0) 100%);
    opacity: 0.1;
    position: absolute;
    bottom: 100%;
    animation: scanline 6s linear infinite;
  }

  @keyframes scanline {
    0% { bottom: 100%; }
    100% { bottom: -100px; }
  }

  /* CYBER GRID */
  .cyber-grid {
    background-image: linear-gradient(rgba(0, 255, 255, 0.05) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(0, 255, 255, 0.05) 1px, transparent 1px);
    background-size: 50px 50px;
    background-position: center center;
  }

  .hotspot-input {
    @apply w-full h-full bg-[#0F0B1A]/90 border border-cyan-500/50 rounded-lg p-2 text-white text-2xl outline-none font-bold font-sans text-center;
  }
  .hotspot-btn {
    @apply absolute w-full h-full opacity-0 cursor-pointer z-50;
  }
  .hotspot-value {
    @apply absolute w-full h-full bg-[#151525] flex items-center justify-end pr-4 text-xl font-bold font-sans text-gray-100 rounded-md;
  }
}

